import React from 'react';
import { Team } from '@/types/database';
import { TeamCard } from './TeamCard';
import { useTeamMemberCount } from '@/hooks/useTeamMemberCount';

interface TeamCardWithMemberCountProps {
  team: Team;
  sport?: string;
  location?: string;
  onViewDetails?: () => void;
}

export const TeamCardWithMemberCount: React.FC<TeamCardWithMemberCountProps> = ({
  team,
  sport,
  location,
  onViewDetails
}) => {
  const { memberCount, loading } = useTeamMemberCount(team.team_id);

  return (
    <TeamCard
      team={team}
      memberCount={loading ? 0 : memberCount}
      sport={sport || 'Sports'}
      location={location || 'Location TBD'}
      onViewDetails={onViewDetails}
    />
  );
};